// A field key as a sentence-case label that keeps the capitals of known
// abbreviations: "po_number" reads "PO number", "invoiceDate" reads
// "Invoice date" (docs/ui_style_guide.md, Type). Mirrors
// PaperworksHelper#extracted_data_label and its EXTRACTED_DATA_LABEL_ACRONYMS.
export const LABEL_ACRONYMS = new Set([
  "ach", "ap", "ar", "asn", "bic", "bol", "cad", "eft", "ein", "eta", "etd", "eur", "fob", "gbp", "gl", "gst", "gtin", "hst", "iban", "id",
  "po", "pdf", "rma", "scac", "sku", "so", "ssn", "tin", "uom", "upc", "url", "usd", "vat", "vin"
])

export function fieldLabel (key) {
  return String(key ?? "")
    .replace(/([a-z\d])([A-Z])/g, "$1_$2")
    .replace(/[_\-\s]+/g, " ")
    .trim()
    .split(" ")
    .filter(Boolean)
    .map((word, index) => {
      const lower = word.toLowerCase()
      if (LABEL_ACRONYMS.has(lower)) return lower.toUpperCase()
      return index === 0 ? lower.charAt(0).toUpperCase() + lower.slice(1) : lower
    })
    .join(" ")
}
